"use strict";

// eslint-disable-next-line no-unused-vars
const initGallery = () => {
  let currentImage = null;
  const galleryOverlay = document.querySelector("#gallery-overlay");
  if (galleryOverlay == null) {
    return;
  }
  galleryOverlay.addEventListener("click", e => {
    var _e$target$parentEleme, _e$target$parentEleme2;
    if (e.target.classList.contains("controls") || (_e$target$parentEleme = e.target.parentElement) !== null && _e$target$parentEleme !== void 0 && _e$target$parentEleme.classList.contains("controls") || (_e$target$parentEleme2 = e.target.parentElement) !== null && _e$target$parentEleme2 !== void 0 && (_e$target$parentEleme2 = _e$target$parentEleme2.parentElement) !== null && _e$target$parentEleme2 !== void 0 && _e$target$parentEleme2.classList.contains("controls")) {
      return;
    }
    console.log(e.target);
    galleryOverlay.classList.add("hidden");
  });
  document.querySelectorAll(".gallery-image").forEach(image => image.addEventListener("click", () => loadImage(image)));
  const loadImage = elm => {
    currentImage = parseInt(elm.getAttribute("image"));
    galleryOverlay.querySelector("img").src = "";
    galleryOverlay.querySelector("img").src = elm.getAttribute("load");
    galleryOverlay.classList.remove("hidden");
  };
  const switchImage = direction => {
    if (currentImage === null) {
      return;
    }
    let nextImage = currentImage + direction;
    // eslint-disable-next-line no-undef
    if (nextImage > maxImages) {
      nextImage = 1;
    } else if (nextImage < 1) {
      // eslint-disable-next-line no-undef
      nextImage = maxImages;
    }
    const nextImageElement = document.querySelector("img[image=\"".concat(nextImage, "\"]"));
    if (nextImageElement === null) {
      return;
    }
    loadImage(nextImageElement);
  };
  const nextButton = document.querySelector("#controls-next");
  if (nextButton) {
    nextButton.addEventListener("click", () => {
      switchImage(1);
    });
  }
  const previousButton = document.querySelector("#controls-prev");
  if (previousButton) {
    previousButton.addEventListener("click", () => {
      switchImage(-1);
    });
  }
  document.addEventListener("keydown", e => {
    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
      switchImage(e.key === "ArrowRight" ? 1 : -1);
    }
  });
};
initGallery();
//# sourceMappingURL=gallery.js.map